import { render, staticRenderFns } from "./SaleInvoicesRetentionListFiltersForm.vue?vue&type=template&id=0db87391&scoped=true&"
import script from "./SaleInvoicesRetentionListFiltersForm.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesRetentionListFiltersForm.vue?vue&type=script&lang=js&"
import style0 from "./SaleInvoicesRetentionListFiltersForm.vue?vue&type=style&index=0&id=0db87391&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db87391",
  null
  
)

export default component.exports